const cache = new Map<string, Intl.DateTimeFormat>();

const OPTIONS: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit', timeZone: 'UTC' };

const formatterFor = (locale: string): Intl.DateTimeFormat => {
  const cached = cache.get(locale);
  if (cached) return cached;
  let formatter: Intl.DateTimeFormat;
  try {
    formatter = new Intl.DateTimeFormat(locale, OPTIONS);
  } catch {
    formatter = new Intl.DateTimeFormat('en', OPTIONS);
  }
  cache.set(locale, formatter);
  return formatter;
};

const MS_PER_MINUTE = 60_000;

export const formatClockTime = (minuteOfDay: number, locale: string): string =>
  formatterFor(locale).format(new Date(minuteOfDay * MS_PER_MINUTE));
